export enum TravelRangeType {
  LocalTravel = 0,
  InterContinentalTravel = 1,
}
